module.exports = __webpack_public_path__ + "img/ej-footer@2x.68ac6837.png";